export const LV_ADLocationTR={
ADLoID:{en:'ADLoID',cs:'ADLoID',dataType:'number',format:'#0',required:true},
ADLoLocationName:{en:'Location',cs:'',dataType:'string',required:true,maxLength:100},
ADLoTimeStamp:{en:'ADLoTimeStamp',cs:'ADLoTimeStamp',dataType:'number',format:'#0'}
}